import { type JSONData } from "../../base_classes/dto.d";
import { Dto } from "../../base_classes/dto";
import { type IMediaDto } from "./dto.gen.d";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

// ENUMS
export enum ContentType {
  IMAGE = "image",
  VIDEO = "video",
  AUDIO = "audio",
  FILE = "file",
}
export const ContentTypeValues = Object.values(ContentType);
export const toContentType = (s: string): ContentType => {
  switch (s) {
    case "image":
      return ContentType.IMAGE;
    case "video":
      return ContentType.VIDEO;
    case "audio":
      return ContentType.AUDIO;
    case "file":
      return ContentType.FILE;
    default:
      return ContentType.IMAGE;
  }
};

export class MediaDto extends Dto implements IMediaDto {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/media/{id}";
  _reference = "/Media/{id}";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  contentType = ContentType.IMAGE;

  description = "";

  extension = "";

  filename = "";

  mimeType = "";

  size = "";

  storagePath = "";

  url = "";

  /// ///////////////////////////////////////
  /// ///////////// METHODS /////////////////
  /// ///////////////////////////////////////

  static FromJSON(data: unknown): MediaDto {
    // Create a new instance of the class
    const obj = new MediaDto();
    obj.set(data as JSONData);
    return obj;
  }

  static FromJSONArray(data: unknown[]): MediaDto[] {
    return data.map((item) => MediaDto.FromJSON(item));
  }

  override set(data: JSONData): void {
    super.set(data);

    // Implement variables here
    if (data.contentType !== undefined && data.contentType !== null) {
      this.contentType = toContentType(
        (data?.contentType as string) ?? this.contentType,
      );
    }
    if (data.description !== undefined && data.description !== null) {
      this.description = (data.description as string) ?? this.description;
    }
    if (data.extension !== undefined && data.extension !== null) {
      this.extension = (data.extension as string) ?? this.extension;
    }
    if (data.filename !== undefined && data.filename !== null) {
      this.filename = (data.filename as string) ?? this.filename;
    }
    if (data.mimeType !== undefined && data.mimeType !== null) {
      this.mimeType = (data.mimeType as string) ?? this.mimeType;
    }
    if (data.size !== undefined && data.size !== null) {
      this.size = (data.size as string) ?? this.size;
    }
    if (data.storagePath !== undefined && data.storagePath !== null) {
      this.storagePath = (data.storagePath as string) ?? this.storagePath;
    }
    if (data.url !== undefined && data.url !== null) {
      this.url = (data.url as string) ?? this.url;
    }
  }
}
